import { ArrowUpRight, PanelLeft } from "lucide-react";
import { useSession } from "../../features/auth/useSession";

interface TopBarProps {
	title: string;
	onToggleSidebar: () => void;
}

export const TopBar = ({ title, onToggleSidebar }: TopBarProps) => {
	const { data } = useSession();

	return (
		<header className="sticky top-2 z-20 flex h-14 shrink-0 items-center gap-3 rounded-t-[9px] border-b border-line bg-glass px-4 backdrop-blur-xl backdrop-saturate-150">
			<button
				type="button"
				onClick={onToggleSidebar}
				aria-label="Toggle sidebar"
				className="flex h-8 w-8 items-center justify-center rounded-md text-ink-muted transition-colors hover:bg-raised hover:text-ink"
			>
				<PanelLeft className="h-4 w-4" strokeWidth={1.75} />
			</button>
			<div className="h-4 w-px bg-line" />
			<h1 className="text-sm font-medium text-ink">{title}</h1>

			{data ? (
				<a
					href={`https://${data.tenant.shopDomain}`}
					target="_blank"
					rel="noreferrer"
					title={data.tenant.shopDomain}
					className="ml-auto inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-medium text-ink transition-colors hover:bg-raised"
				>
					{data.tenant.name ?? data.tenant.shopDomain}
					<ArrowUpRight className="h-3.5 w-3.5 text-ink-faint" strokeWidth={2} />
				</a>
			) : null}
		</header>
	);
};
